// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1lA2q","footer":"ModalInfo_footer__GlzUv"};